import { useMutation, useQuery } from '@tanstack/react-query';
import { QueryKey } from 'src/query-client';

import { PjmSeasonDto, UpdatePjmSeasonDto } from './PjmSeasonDto';
import { API } from '../../api';

export const usePjmSeasonUpdateMutation = () => {
    return useMutation<PjmSeasonDto, Error, UpdatePjmSeasonDto>({
        mutationFn: dto => updatePjmSeason(dto),
    });
};

const updatePjmSeason = async (dto: UpdatePjmSeasonDto): Promise<PjmSeasonDto> => {
    const response = await API.fetch(`/pjm/seasons/${dto.id}`, {
        method: 'put',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ peakDays: dto.peakDays }),
    });
    const respBody: any = await response.json();

    if (response.ok) {
        return respBody as PjmSeasonDto;
    }

    throw new Error(respBody?.error?.message || `Cannot update PJM season!`);
};

export const getSeasonById = async (id: string, signal?: AbortSignal | null): Promise<PjmSeasonDto | null> => {
    const response = await API.fetch(`/pjm/seasons/${id}`, {
        ...(signal && { signal }),
        headers: {
            'Content-Type': 'application/json',
        },
    });

    // 204 No Content → valid case, no season
    if (response.status === 204) {
        return null;
    }

    const respBody: any = await response.json();

    if (response.ok) {
        return respBody;
    }

    throw new Error(respBody?.error?.message || `Cannot get PJM season!`);
};

export const usePjmSeasonQuery = (id: string, options = {}) => {
    return useQuery<PjmSeasonDto | null, Error>({
        queryKey: [QueryKey.PJM_SEASON, id],
        queryFn: ({ signal }) => getSeasonById(id, signal),
        ...options,
    });
};
